import $ from "jquery";
import { application } from "../application/application";
import { dataaccess } from "../dataaccess/dataContext";
import { services } from "../services/notificationService";

function init() {
    setEvents();
}
function setEvents() {
    $("#deactivate-dropdown a").click(deactivatedropdownclick);

    $("#activate-dropdown a").click(activatedropdownclick);
}

function activatedropdownclick() {
    const url = "/attestation/activate/" + $("#attestationId").val();
    dataaccess
        .put({ url: url })
        .done(function () {
            window.location.href =
                application.baseUrl + "/attestation/index/" + $("#attestationId").val();
            services.notificationService.success("Successfully Activated");
        });
}
function deactivatedropdownclick() {
    const url = "/attestation/deactivate/" + $("#attestationId").val();
    dataaccess
        .put({ url: url })
        .done(function () {
            window.location.href =
                application.baseUrl + "/attestation/index/" + $("#attestationId").val();
            services.notificationService.success("Successfully Deactivated");
        });
}

export const attestation = {
    init: init
};
